/**
 *  AVIS JS
 *  Get/add/delete/modify
 */


$(document).ready(function () {

    if (document.getElementById('avis_hidden')) {
        /* create Avis */
        var modal = document.getElementById("myAvisModal");
        var btn = document.getElementById("popupCreateAvis");
        var span = document.getElementsByClassName("close")[0];
        btn.onclick = function () {
            modal.style.display = "block";
        };
        span.onclick = function () {
            modal.style.display = "none";
        };
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        };
        $('#avis_create_btn').on('click', function () {
            if (confirm(trans('page.management.avis.add_avis_question'))) {
                let skuElem = $("#createModal_items input[name^=product_sku]");
                let quantityElem = $("#createModal_items input[name^=quantity]");
                let skus = [];
                let quantities = [];

                skuElem.each(function () {
                    skus.push(this.value.split(" - ", 2)[0]);
                });

                quantityElem.each(function () {
                    quantities.push(this.value);
                });

                $.ajax({
                    url: '/manage/storage/avis/create',
                    type: "post",
                    dataType: "json",
                    data: {
                        deliveryNoteNumber: $('#createModal_delivery_note_number').val(),
                        supplierId: $('#createModal_supplier option:selected').val(),
                        deliveryDate: $('#createModal_datepicker').val(),
                        skus: skus,
                        quantities: quantities,
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.product.view.product_was_created'));
                        location.reload();
                    },
                    error: function (data) {
                        let json = data.responseJSON;
                        let errorMsg = trans('page.management.avis.avis_error');
                        let errors = Object.values(json.errors)

                        errors.forEach(function (value) {
                            if( value.isArray === true ){
                                value.forEach(function (msg) {
                                    errorMsg = errorMsg + '\n' + msg;
                                })
                            } else {
                                errorMsg = errorMsg + '\n' + value;
                            }
                        });

                        alert(errorMsg);
                    }
                });
            }
        });
        $('#avis_edit_btn').on('click', function () {
            $.ajax({
                url: 'manage/storage/avis/update/' + $('#hidden_update_field').val(),
                type: "post",
                dataType: "json",
                data: {
                    avisNumber: $('#editModal_avis_number').val(),
                    deliveryNoteNumber: $('#editModal_delivery_note_number').val(),
                    supplierId: $('#editModal_supplier option:selected').val(),
                    deliveryDate: $('#editModal_datepicker').val(),
                    status: $('#editModal_status option:selected').val(),
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();

                },
                error: function () {
                }
            });
        });
        $('.avis_update_btn').on('click', function () {
            if (confirm(trans('page.management.avis.edit_avis'))) {
                let split = this.id.split("_", 2);
                let modal = document.getElementById("myAvisModalEdit");
                modal.style.display = "block";
                window.onclick = function (event) {
                    if (event.target == modal) {
                        modal.style.display = "none";
                    }
                };
                $.ajax({
                    url: '/manage/storage/avis/get_avis/' + split[1],
                    type: "get",
                    dataType: "json",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $('#editModal_avis_number').val(data["avis_number"]);
                        $('#editModal_delivery_note_number').val(data["delivery_note_number"]);
                        $('#editModal_supplier option[value="'+ data["supplier_id"]+'"]')[0].selected = true;
                        $('#editModal_datepicker').val(data["delivery_date"]);
                        $('#editModal_status option[value="'+ data["status_id"]+'"]')[0].selected = true;
                    },
                    error: function () {
                        modal.style.display = "none";
                    }
                });

            } else {
            }
        });
        $('.avis_delete_btn').on('click', function () {
            if (confirm(trans('page.manage.avis.delete_avis'))) {
                let split = this.id.split("_", 2);
                $.ajax({
                    url: '/manage/storage/avis/delete/' + split[1],
                    type: "post",
                    dataType: "json",
                    data: {},
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.product.view.product_was_deleted'));
                        location.reload();

                    },
                    error: function () {
                    }
                });
            } else {
            }
        });
    }
});